import {commonPageData} from "./common";

require('./common')
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('turniketpage', require('./components/turniket/TurniketPage.vue').default);
Vue.component('tourniquetdetails', require('./components/turniket/TourniquetDetails.vue').default);
Vue.component('reviewform', require('./components/ReviewForm.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

const app = new Vue({
    el: '#app',
    pinia
});

const tourniquetDetails = new Vue({
    el: '#tourniquetDetails'
});

export let vueData = Vue.observable({
    showReviewForm: false,
    isEdit: false,
    tourniquetReviewName: '',
    tourniquetReviewId: null,
    tourniquetReviewEditedId: null,
    tourniquetReviewText: '',
    tourniquetReviewConclusion: '',
    tourniquetReviewImages: [],
    tourniquetReviewDocs: [],
});

const reviewFormComponent = new Vue({
    el: '#reviewForm',
    computed: {
        showForm() {
            return vueData.showReviewForm;
        }
    }
});

document.querySelector('[data-event="show-review-form"]')?.addEventListener('click', function (e) {
    e.preventDefault();
    vueData.isEdit = false;
    vueData.showReviewForm = true;
    vueData.tourniquetReviewName = document.querySelector('[data-block="tourniquet-name"]').innerText;
    vueData.tourniquetReviewId = +document.querySelector('[data-block="tourniquet-name"]').dataset.id;
})

document.querySelector('[data-el="tourniquet-image"]').addEventListener('error', function (){
    document.querySelector('[data-el="tourniquet-image-block"]').innerHTML='<svg width="300" height="300" viewBox="0 0 300 300" fill="none" style="max-width: 100%" xmlns="http://www.w3.org/2000/svg">\n' +
        '        <rect width="300" height="300" fill="#F8F8F8"/>\n' +
        '        <path d="M199.271 92H100.271C91.3863 92 84 99.3863 84 108.5V191C84 200.114 91.3863 207.5 100.268 207.5H199.268C208.382 207.5 215.768 200.114 215.768 191V108.5C215.771 99.3863 208.603 92 199.271 92ZM112.646 108.5C119.48 108.5 125.021 114.04 125.021 120.875C125.021 127.71 119.71 133.25 112.646 133.25C105.581 133.25 100.271 127.71 100.271 120.875C100.271 114.04 106.04 108.5 112.646 108.5ZM199.013 188.834C198.291 190.175 196.899 191 195.378 191H105.146C104.384 191 103.638 190.789 102.989 190.391C102.34 189.993 101.814 189.423 101.469 188.744C101.124 188.065 100.974 187.304 101.034 186.545C101.095 185.786 101.365 185.059 101.813 184.444L119.86 159.694C120.638 158.619 121.875 158 123.19 158C124.505 158 125.747 158.629 126.524 159.695L134.892 171.17L158.946 135.308C159.722 133.946 161.011 133.25 162.378 133.25C163.744 133.25 165.046 133.939 165.809 135.087L198.809 184.587C199.657 185.844 199.735 187.468 199.013 188.834Z" fill="#CED0D2"/>\n' +
        '    </svg>'
})

const openManufacturerModalBtn = document.querySelector('[data-event="open-manufacturer-modal"]');
const manufacturerModal = document.querySelector('[data-block="manufacturer-modal"]');
const closeManufacturerModalBtn = document.querySelector('[data-event="close-manufacturer-modal"]');

openManufacturerModalBtn.addEventListener('click', function (){
    manufacturerModal.classList.add('active');
    document.querySelector('body').classList.add('modal-open')
    checkModalAlign();

    window.addEventListener('resize', function (){
        checkModalAlign();
    })
    function checkModalAlign() {
        if (manufacturerModal.querySelector('.custom-modal-content').offsetHeight + 50 > window.innerHeight) {
            manufacturerModal.classList.add('align-start')
        } else {
            manufacturerModal.classList.remove('align-start')
        }
    }
})

closeManufacturerModalBtn.addEventListener('click', function (){
    manufacturerModal.classList.remove('active');
    document.querySelector('body').classList.remove('modal-open')
})


